// 주소/장소 API 파사드 — 좌표 기반으로 국내(카카오) / 해외(Google·Nominatim) 자동 분기.
// 소비 컴포넌트는 이 모듈만 import 하며 시그니처는 유지된다.
import * as intl from './addressApi.intl';
import * as kr from './addressApi.kr';
import { resolveDomestic } from '../utils/regionState';

// 장소 검색 (좌표가 없어 자동판정 불가 → MapPicker가 넘기는 providerHint로 결정, 기본 해외)
export const searchAddress = (query, succFunc, providerHint) => {
    if (providerHint === 'kakao') kr.searchAddress(query, succFunc);
    else intl.searchAddress(query, succFunc);
};

// 역지오코딩 (x=경도, y=위도) — 좌표로 국내/해외 분기
export const getAddress = (x, y, succFunc) => {
    if (resolveDomestic(y, x)) kr.getAddress(x, y, succFunc);
    else intl.getAddress(x, y, succFunc);
};
